import ontologiesAxios from "./axiosInstance/ontologies";

const fetchIcdDescriptions = payload =>
  ontologiesAxios.get(`/icdcode/${payload}`);

const fetchIcdCode = payload =>
  ontologiesAxios.post(`/icddesc/${payload}`, payload);

const icdApi = {
  fetchIcdDescriptions,
  fetchIcdCode,
};

export default icdApi;
